/* unplugin-vue-components disabled */import { render } from "./SuccessQuizPlayer.vue?vue&type=template&id=17738a24&ts=true"
import script from "./SuccessQuizPlayer.vue?vue&type=script&lang=ts"
export * from "./SuccessQuizPlayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__